module.exports = __webpack_public_path__ + "static/media/night.d786887c.mov";